<p-table stripedRows #dtChargeNumber
    [value]="items"
    dataKey="id"
    editMode="row"
    [(selection)]="selected"
    scrollHeight="flex"
    [scrollable]="true"
    selectionMode="single"
    (onRowSelect)="this.SelectItem.next($event.data)"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="10" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
        <tr>
            <td colspan="10" style="text-align: center">
                <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header let-item>
        <tr>
            <!-- status-->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Selection -->
            <!-- <th style="width: 3em; text-align: center" >
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
    </th> -->
            <!-- Edit -->
            <!-- <th style="width: 6em; text-align: center">
                    <i
                        class="fa far fa-edit"
                        style="font-size: 1.5em"
                        title="Edit"
                    ></i>
                </th> -->
            <!-- Charge Number -->
            <th>
                Charge Number
                <p-sortIcon
                    pSortableColumn="ChargeNumber"
                    field="ChargeNumber"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter field="ContractListID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            defaultLabel="Filter"
                            maxSelectedLabels="1"
                            appendTo="body"
                            [options]="contracts"
                            [filter]="true"
                            styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                        ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Schedule Start Date -->
            <th>
                Schedule Start Date
                <p-sortIcon
                    pSortableColumn="ScheduledStartDate"
                    field="ScheduledStartDate"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Scheduled End Date -->
            <th>
                Scheduled End Date
                <p-sortIcon
                    pSortableColumn="ScheduledEndDate"
                    field="ScheduledEndDate"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Scheduled Amount -->
            <th>
                FP Amount
                <p-sortIcon
                    pSortableColumn="Scheduledamount"
                    field="Scheduledamount"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Last Modified Date -->
            <!-- <th style="width: 12em">
                    <div class="tabulator-col-content">
                        <div class="tabulator-col-title">
                            Last Modified Date
                        </div>
                        <p-sortIcon
                            pSortableColumn="LastModifiedDate"
                            field="LastModifiedDate"
                            ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"
                        ></p-sortIcon>
                    </div>
                </th> -->
            <!-- Invoice Number -->
            <th>
                Invoice
                <p-sortIcon
                    pSortableColumn="InvoiceNbr"
                    field="InvoiceNbr"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Start Date -->
            <th>
                Start Date
                <p-sortIcon
                    pSortableColumn="InvoiceStart"
                    field="InvoiceStart"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- End Date -->
            <th>
                End Date
                <p-sortIcon
                    pSortableColumn="InvoiceEnd"
                    field="InvoiceEnd"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Invoice Date -->
            <th>
                Invoice Date
                <p-sortIcon
                    pSortableColumn="InvoiceDate"
                    field="InvoiceDate"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Invoice Amount -->
            <th>
                Invoice Amount
                <p-sortIcon
                    pSortableColumn="InvoiceAmount"
                    field="InvoiceAmount"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template
        #body
        let-item
        let-edit="editing"
        let-ri="rowIndex"
        let-rowData
    >
        <tr
            [pSelectableRow]="item"
            [pEditableRow]="item"
            data-id="row-{{ item.id }}"
            [ngClass]="{
                'ui-editing-row': edit && editing?.id === rowData?.id
            }"
        >
            <!-- Status-->
            <td class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Selection -->
            <!-- <td
                        style="width: 3em; text-align: center"
                        class="small-cell"
                    >
                        <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                    </td> -->
            <!-- Edit -->
            <!-- <td
                    style="
                        width: 6em;
                        text-align: center;
                        vertical-align: middle;
                    "
                    class="small-cell"
                >
                    <div style="display: flex; justify-content: space-around">
                        <button
                            *ngIf="item?.id === 'add' && !edit"
                            pButton
                            type="button"
                            pInitEditableRow
                            icon="pi pi-plus"
                            class="ef-button-success ef-circle-button"
                            (click)="onRowEditInit(item)"
                        ></button>
                        <button
                            *ngIf="
                                !edit &&
                                (!editing?.id || editing?.id === item?.id) &&
                                item.id !== 'add'
                            "
                            pButton
                            type="button"
                            pInitEditableRow
                            icon="pi pi-pencil"
                            class="ef-button-default ef-circle-button"
                            (click)="onRowEditInit(item)"
                        ></button>
                        <button
                            *ngIf="edit"
                            pButton
                            type="button"
                            pSaveEditableRow
                            icon="pi pi-check"
                            class="ef-button-success ef-circle-button"
                            (click)="onRowEditSave(item)"
                        ></button>
                        <button
                            *ngIf="edit"
                            pButton
                            type="button"
                            pCancelEditableRow
                            icon="pi pi-times"
                            class="ef-button-danger ef-circle-button"
                            (click)="onRowEditCancel(item)"
                        ></button>
                    </div>
                </td> -->
            <!-- Charge Number -->
            <td class="disabled" [title]="item.ChargeNumber">
                {{ item.ChargeNumber }}
            </td>
            <!-- Schedule Start Date -->
            <td class="disabled">
                {{
                    moment(item?.ScheduledStartDate).isValid()
                        ? moment(item?.ScheduledStartDate).format('MM/DD/YYYY')
                        : ''
                }}
            </td>
            <!-- Scheduled End Date -->
            <td class="disabled">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <p-calendar
                            inputStyleClass="p-inputtext"
                            [(ngModel)]="item.ScheduledEndDate"
                            [ngModelOptions]="{ standalone: true }"
                            appendTo="body"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            yearRange="2000:2030"
                            [readonlyInput]="false"
                            dateFormat="mm/dd/yy"
                            [required]="true"
                        >
                        </p-calendar>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                            moment(item?.ScheduledEndDate).isValid()
                                ? moment(item?.ScheduledEndDate).format(
                                      'MM/DD/YYYY'
                                  )
                                : ''
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                            moment(item?.ScheduledEndDate).isValid()
                                ? moment(item?.ScheduledEndDate).format(
                                      'MM/DD/YYYY'
                                  )
                                : ''
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Scheduled Amount -->
            <td class="disabled currency">
                {{ item?.ScheduledAmount | currency }}
            </td>
            <!-- Last Modified Date -->
            <!-- <td class="small-cell">
                    {{
                        moment(item?.LastModifiedDate).isValid()
                            ? moment(item?.LastModifiedDate).format(
                                  'MM/DD/YYYY'
                              )
                            : ''
                    }}
                </td> -->
            <!-- Invoice Number -->
            <td class="disabled">
                {{ item?.InvoiceNbr }}
            </td>
            <!-- Start Date -->
            <td class="disabled">
                {{
                    moment(item?.InvoiceStart).isValid()
                        ? moment(item?.InvoiceStart).format('MM/DD/YYYY')
                        : ''
                }}
            </td>
            <!-- End Date -->
            <td class="disabled">
                {{
                    moment(item?.InvoiceEnd).isValid()
                        ? moment(item?.InvoiceEnd).format('MM/DD/YYYY')
                        : ''
                }}
            </td>
            <!-- Invoice Date -->
            <td class="disabled">
                {{
                    moment(item?.InvoiceDate).isValid()
                        ? moment(item?.InvoiceDate).format('MM/DD/YYYY')
                        : ''
                }}
            </td>
            <!-- Invoice Amount -->
            <td class="disabled currency">
                {{ item?.InvoiceAmount | currency }}
            </td>
        </tr>
    </ng-template>
</p-table>
